// Full i18n for the Gestos Ágeis presentation/landing page — 6 languages
// (PT, EN, ES, FR, IT, DE). Falls back to PT for any missing language.

export const gaPageStrings = {
  pt: {
    bestSellers: 'Mais procurados',
    cities: 'Cidades',
    rentalDaysYear: 'Dias de aluguer/Ano',
    customers: 'Clientes',
    readyToRent: 'Pronto para alugar?',
    startJourney: 'Comece a sua jornada de aluguer de equipamento hoje',
    aboutUs: 'Sobre Nós',
    leadingOrtho: 'Serviço de aluguer de equipamentos ortopédicos líder.',
    services: 'Serviços',
    equipmentRental: 'Aluguer de Equipamento',
    deliveryPickup: 'Entrega e Levantamento',
    support: 'Suporte',
    legal: 'Legal',
    privacy: 'Privacidade',
    terms: 'Termos',
    cookies: 'Cookies',
    contact: 'Contacto',
    copyright: '© 2026 Gestos Ágeis. Todos os direitos reservados.',
    testimonialsTitle: 'O que dizem os nossos clientes',
    support24h: 'Atendimento 24 Horas',
    availableAnytime: 'Estamos disponíveis a qualquer hora do dia ou da noite',
    phone24h: 'Telefone 24h',
    localRateCall: 'Chamada para a rede fixa nacional',
    message: 'Mensagem',
    faq: 'Perguntas Frequentes',
    wheelchairs: 'Cadeiras de Rodas',
    walkers: 'Andarilhos',
    hospitalBeds: 'Camas Articuladas',
    faqTitle: 'Perguntas Frequentes',
    seeAllFaqs: 'Ver todas as perguntas →',
  },
  en: {
    bestSellers: 'Best sellers',
    cities: 'Cities',
    rentalDaysYear: 'Rental Days/Year',
    customers: 'Customers',
    readyToRent: 'Ready to rent?',
    startJourney: 'Start your equipment rental journey today',
    aboutUs: 'About Us',
    leadingOrtho: 'Leading orthopedic equipment rental service.',
    services: 'Services',
    equipmentRental: 'Equipment Rental',
    deliveryPickup: 'Delivery & Pickup',
    support: 'Support',
    legal: 'Legal',
    privacy: 'Privacy',
    terms: 'Terms',
    cookies: 'Cookies',
    contact: 'Contact',
    copyright: '© 2026 Gestos Ágeis. All rights reserved.',
    testimonialsTitle: 'What our customers say',
    support24h: '24-Hour Support',
    availableAnytime: 'We are available at any time of the day or night',
    phone24h: 'Phone 24h',
    localRateCall: 'Local rate call',
    message: 'Message',
    faq: 'FAQ',
    wheelchairs: 'Wheelchairs',
    walkers: 'Walkers',
    hospitalBeds: 'Hospital Beds',
    faqTitle: 'Frequently Asked Questions',
    seeAllFaqs: 'See all FAQs →',
  },
  es: {
    bestSellers: 'Más buscados',
    cities: 'Ciudades',
    rentalDaysYear: 'Días de alquiler/Año',
    customers: 'Clientes',
    readyToRent: '¿Listo para alquilar?',
    startJourney: 'Comience su viaje de alquiler de equipos hoy',
    aboutUs: 'Sobre Nosotros',
    leadingOrtho: 'Servicio líder de alquiler de equipos ortopédicos.',
    services: 'Servicios',
    equipmentRental: 'Alquiler de Equipos',
    deliveryPickup: 'Entrega y Recogida',
    support: 'Soporte',
    legal: 'Legal',
    privacy: 'Privacidad',
    terms: 'Términos',
    cookies: 'Cookies',
    contact: 'Contacto',
    copyright: '© 2026 Gestos Ágeis. Todos los derechos reservados.',
    testimonialsTitle: 'Lo que dicen nuestros clientes',
    support24h: 'Atención 24 Horas',
    availableAnytime: 'Estamos disponibles a cualquier hora del día o de la noche',
    phone24h: 'Teléfono 24h',
    localRateCall: 'Llamada a tarifa local',
    message: 'Mensaje',
    faq: 'Preguntas Frecuentes',
    wheelchairs: 'Sillas de Ruedas',
    walkers: 'Andadores',
    hospitalBeds: 'Camas Articuladas',
    faqTitle: 'Preguntas Frecuentes',
    seeAllFaqs: 'Ver todas las preguntas →',
  },
  fr: {
    bestSellers: 'Les plus demandés',
    cities: 'Villes',
    rentalDaysYear: 'Jours de location/An',
    customers: 'Clients',
    readyToRent: 'Prêt à louer ?',
    startJourney: "Commencez votre location d'équipement dès aujourd'hui",
    aboutUs: 'À Propos',
    leadingOrtho: "Service leader de location d'équipements orthopédiques.",
    services: 'Services',
    equipmentRental: "Location d'Équipement",
    deliveryPickup: 'Livraison et Retrait',
    support: 'Support',
    legal: 'Mentions légales',
    privacy: 'Confidentialité',
    terms: 'Conditions',
    cookies: 'Cookies',
    contact: 'Contact',
    copyright: '© 2026 Gestos Ágeis. Tous droits réservés.',
    testimonialsTitle: 'Ce que disent nos clients',
    support24h: 'Assistance 24h/24',
    availableAnytime: 'Nous sommes disponibles à toute heure du jour ou de la nuit',
    phone24h: 'Téléphone 24h',
    localRateCall: 'Appel au tarif local',
    message: 'Message',
    faq: 'Questions Fréquentes',
    wheelchairs: 'Fauteuils Roulants',
    walkers: 'Déambulateurs',
    hospitalBeds: 'Lits Articulés',
    faqTitle: 'Questions Fréquentes',
    seeAllFaqs: 'Voir toutes les questions →',
  },
  it: {
    bestSellers: 'Più richiesti',
    cities: 'Città',
    rentalDaysYear: 'Giorni di noleggio/Anno',
    customers: 'Clienti',
    readyToRent: 'Pronto per noleggiare?',
    startJourney: 'Inizia il tuo noleggio di attrezzature oggi',
    aboutUs: 'Chi Siamo',
    leadingOrtho: 'Servizio leader di noleggio di attrezzature ortopediche.',
    services: 'Servizi',
    equipmentRental: 'Noleggio Attrezzature',
    deliveryPickup: 'Consegna e Ritiro',
    support: 'Supporto',
    legal: 'Legale',
    privacy: 'Privacy',
    terms: 'Termini',
    cookies: 'Cookie',
    contact: 'Contatto',
    copyright: '© 2026 Gestos Ágeis. Tutti i diritti riservati.',
    testimonialsTitle: 'Cosa dicono i nostri clienti',
    support24h: 'Assistenza 24 Ore',
    availableAnytime: 'Siamo disponibili a qualsiasi ora del giorno o della notte',
    phone24h: 'Telefono 24h',
    localRateCall: 'Chiamata a tariffa locale',
    message: 'Messaggio',
    faq: 'Domande Frequenti',
    wheelchairs: 'Carrozzelle',
    walkers: 'Deambulatori',
    hospitalBeds: 'Letti Articolati',
    faqTitle: 'Domande Frequenti',
    seeAllFaqs: 'Vedi tutte le domande →',
  },
  de: {
    bestSellers: 'Beliebteste',
    cities: 'Städte',
    rentalDaysYear: 'Vermietungstage/Jahr',
    customers: 'Kunden',
    readyToRent: 'Bereit zu mieten?',
    startJourney: 'Beginnen Sie Ihre Geräte-Mietreise heute',
    aboutUs: 'Über Uns',
    leadingOrtho: 'Führender Vermietungsservice für orthopädische Geräte.',
    services: 'Dienstleistungen',
    equipmentRental: 'Gerätevermietung',
    deliveryPickup: 'Lieferung & Abholung',
    support: 'Support',
    legal: 'Rechtliches',
    privacy: 'Datenschutz',
    terms: 'AGB',
    cookies: 'Cookies',
    contact: 'Kontakt',
    copyright: '© 2026 Gestos Ágeis. Alle Rechte vorbehalten.',
    testimonialsTitle: 'Was unsere Kunden sagen',
    support24h: '24-Stunden-Support',
    availableAnytime: 'Wir sind jederzeit, Tag und Nacht, erreichbar',
    phone24h: 'Telefon 24h',
    localRateCall: 'Anruf zum Ortstarif',
    message: 'Nachricht',
    faq: 'Häufige Fragen',
    wheelchairs: 'Rollstühle',
    walkers: 'Rollatoren',
    hospitalBeds: 'Krankenbetten',
    faqTitle: 'Häufig gestellte Fragen',
    seeAllFaqs: 'Alle Fragen ansehen →',
  },
};

export const gaPageTestimonials = {
  pt: [
    { name: 'Maria Fernanda', city: 'Lisboa', text: 'Serviço excelente! A cadeira de rodas chegou no dia seguinte, em perfeito estado. Recomendo a toda a gente.', stars: 5 },
    { name: 'João Rodrigues', city: 'Porto', text: 'Precisei de uma cama articulada para a minha mãe após uma cirurgia e o processo foi simples e rápido. Muito obrigado!', stars: 5 },
    { name: 'Ana Costa', city: 'Braga', text: 'Preços justos, entrega pontual e equipamento em ótimo estado. Voltarei a utilizar sempre que precisar.', stars: 5 },
    { name: 'Carlos Mendes', city: 'Cascais', text: 'Atendimento ao cliente fantástico. Responderam a todas as minhas dúvidas via WhatsApp em minutos.', stars: 5 },
    { name: 'Sofia Pinto', city: 'Aveiro', text: 'Aluguer de muletas de forma muito fácil. O site é intuitivo e a entrega foi feita conforme combinado.', stars: 4 },
    { name: 'James Wilson', city: 'Londres, UK', text: 'Estive em Lisboa um mês e precisei de uma cadeira de rodas. A Gestos Ágeis entregou no hotel na manhã seguinte. Serviço excecional!', stars: 5 },
    { name: 'Marie Dupont', city: 'Paris, França', text: 'Serviço impecável! Aluguei canadianas durante a estadia no Porto. Entrega rápida e equipamento de qualidade.', stars: 5 },
    { name: 'Klaus Müller', city: 'Berlim, Alemanha', text: 'Serviço muito bom! Aluguei uma cadeira de rodas para o meu pai. Entrega rápida e pessoal simpático.', stars: 5 },
    { name: 'Emily Johnson', city: 'Nova Iorque, EUA', text: 'Aluguei uma cama hospitalar para a minha mãe durante a estadia em Cascais. A equipa foi incrivelmente prestável e profissional.', stars: 5 },
  ],
  en: [
    { name: 'Maria Fernanda', city: 'Lisbon', text: 'Excellent service! The wheelchair arrived the next day in perfect condition. I recommend it to everyone.', stars: 5 },
    { name: 'João Rodrigues', city: 'Porto', text: 'I needed an articulated bed for my mother after surgery and the process was simple and quick. Thank you!', stars: 5 },
    { name: 'Ana Costa', city: 'Braga', text: 'Fair prices, punctual delivery and equipment in great condition. I will use this service again whenever needed.', stars: 5 },
    { name: 'Carlos Mendes', city: 'Cascais', text: 'Fantastic customer service. They answered all my questions via WhatsApp within minutes.', stars: 5 },
    { name: 'Sofia Pinto', city: 'Aveiro', text: 'Renting crutches was very easy. The website is intuitive and delivery was made as agreed.', stars: 4 },
    { name: 'James Wilson', city: 'London, UK', text: 'I was visiting Lisbon for a month and needed a wheelchair. Gestos Ágeis delivered it to my hotel the next morning. Outstanding service!', stars: 5 },
    { name: 'Marie Dupont', city: 'Paris, France', text: 'Impeccable service! I rented crutches during my stay in Porto. Fast delivery and quality equipment.', stars: 5 },
    { name: 'Klaus Müller', city: 'Berlin, Germany', text: 'Very good service! I rented a wheelchair for my father. Quick delivery and friendly staff. Highly recommend.', stars: 5 },
    { name: 'Emily Johnson', city: 'New York, USA', text: 'Rented a hospital bed for my mother during our stay in Cascais. The team was incredibly helpful and professional.', stars: 5 },
  ],
  es: [
    { name: 'Maria Fernanda', city: 'Lisboa', text: '¡Servicio excelente! La silla de ruedas llegó al día siguiente, en perfecto estado. Lo recomiendo a todo el mundo.', stars: 5 },
    { name: 'João Rodrigues', city: 'Porto', text: 'Necesitaba una cama articulada para mi madre tras una cirugía y el proceso fue sencillo y rápido. ¡Muchas gracias!', stars: 5 },
    { name: 'Ana Costa', city: 'Braga', text: 'Precios justos, entrega puntual y equipo en gran estado. Volveré a utilizar el servicio siempre que lo necesite.', stars: 5 },
    { name: 'Carlos Mendes', city: 'Cascais', text: 'Atención al cliente fantástica. Respondieron a todas mis dudas por WhatsApp en minutos.', stars: 5 },
    { name: 'Sofia Pinto', city: 'Aveiro', text: 'Alquilar muletas fue muy fácil. La web es intuitiva y la entrega se realizó según lo acordado.', stars: 4 },
    { name: 'James Wilson', city: 'Londres, Reino Unido', text: 'Estuve en Lisboa un mes y necesitaba una silla de ruedas. Gestos Ágeis la entregó en el hotel a la mañana siguiente. ¡Servicio excepcional!', stars: 5 },
    { name: 'Marie Dupont', city: 'París, Francia', text: '¡Servicio impecable! Alquilé muletas durante mi estancia en Oporto. Entrega rápida y equipo de calidad.', stars: 5 },
    { name: 'Klaus Müller', city: 'Berlín, Alemania', text: '¡Servicio muy bueno! Alquilé una silla de ruedas para mi padre. Entrega rápida y personal amable.', stars: 5 },
    { name: 'Emily Johnson', city: 'Nueva York, EE. UU.', text: 'Alquilé una cama hospitalaria para mi madre durante nuestra estancia en Cascais. El equipo fue increíblemente servicial y profesional.', stars: 5 },
  ],
  fr: [
    { name: 'Maria Fernanda', city: 'Lisbonne', text: 'Service excellent ! Le fauteuil roulant est arrivé le lendemain, en parfait état. Je le recommande à tous.', stars: 5 },
    { name: 'João Rodrigues', city: 'Porto', text: "J'avais besoin d'un lit articulé pour ma mère après une opération et le processus a été simple et rapide. Merci beaucoup !", stars: 5 },
    { name: 'Ana Costa', city: 'Braga', text: "Prix justes, livraison ponctuelle et matériel en excellent état. Je ferai appel à ce service à chaque besoin.", stars: 5 },
    { name: 'Carlos Mendes', city: 'Cascais', text: 'Service client fantastique. Ils ont répondu à toutes mes questions via WhatsApp en quelques minutes.', stars: 5 },
    { name: 'Sofia Pinto', city: 'Aveiro', text: "La location de béquilles a été très simple. Le site est intuitif et la livraison a été faite comme convenu.", stars: 4 },
    { name: 'James Wilson', city: 'Londres, Royaume-Uni', text: "J'étais à Lisbonne un mois et j'avais besoin d'un fauteuil roulant. Gestos Ágeis l'a livré à mon hôtel le lendemain matin. Service exceptionnel !", stars: 5 },
    { name: 'Marie Dupont', city: 'Paris, France', text: "Service impeccable ! J'ai loué des béquilles pendant mon séjour à Porto. Livraison rapide et matériel de qualité.", stars: 5 },
    { name: 'Klaus Müller', city: 'Berlin, Allemagne', text: 'Très bon service ! J’ai loué un fauteuil roulant pour mon père. Livraison rapide et personnel sympa.', stars: 5 },
    { name: 'Emily Johnson', city: 'New York, États-Unis', text: "J'ai loué un lit d'hôpital pour ma mère durant notre séjour à Cascais. L'équipe a été incroyablement serviable et professionnelle.", stars: 5 },
  ],
  it: [
    { name: 'Maria Fernanda', city: 'Lisbona', text: 'Servizio eccellente! La sedia a rotelle è arrivata il giorno dopo, in perfette condizioni. Lo consiglio a tutti.', stars: 5 },
    { name: 'João Rodrigues', city: 'Porto', text: 'Avevo bisogno di un letto articolato per mia madre dopo un intervento e il processo è stato semplice e rapido. Grazie mille!', stars: 5 },
    { name: 'Ana Costa', city: 'Braga', text: 'Prezzi giusti, consegna puntuale e attrezzatura in ottimo stato. Userò di nuovo questo servizio ogni volta che serve.', stars: 5 },
    { name: 'Carlos Mendes', city: 'Cascais', text: 'Servizio clienti fantastico. Hanno risposto a tutte le mie domande via WhatsApp in pochi minuti.', stars: 5 },
    { name: 'Sofia Pinto', city: 'Aveiro', text: 'Noleggiare le stampelle è stato molto facile. Il sito è intuitivo e la consegna è avvenuta come concordato.', stars: 4 },
    { name: 'James Wilson', city: 'Londra, Regno Unito', text: 'Sono stato a Lisbona un mese e avevo bisogno di una sedia a rotelle. Gestos Ágeis l’ha consegnata in hotel la mattina dopo. Servizio eccezionale!', stars: 5 },
    { name: 'Marie Dupont', city: 'Parigi, Francia', text: 'Servizio impeccabile! Ho noleggiato delle stampelle durante il mio soggiorno a Porto. Consegna rapida e attrezzatura di qualità.', stars: 5 },
    { name: 'Klaus Müller', city: 'Berlino, Germania', text: 'Servizio molto buono! Ho noleggiato una sedia a rotelle per mio padre. Consegna rapida e personale gentile.', stars: 5 },
    { name: 'Emily Johnson', city: 'New York, USA', text: 'Ho noleggiato un letto ospedaliero per mia madre durante il nostro soggiorno a Cascais. Il team è stato incredibilmente disponibile e professionale.', stars: 5 },
  ],
  de: [
    { name: 'Maria Fernanda', city: 'Lissabon', text: 'Ausgezeichneter Service! Der Rollstuhl kam am nächsten Tag in einwandfreiem Zustand. Ich empfehle es jedem.', stars: 5 },
    { name: 'João Rodrigues', city: 'Porto', text: 'Ich brauchte ein verstellbares Bett für meine Mutter nach einer Operation und der Ablauf war einfach und schnell. Vielen Dank!', stars: 5 },
    { name: 'Ana Costa', city: 'Braga', text: 'Faire Preise, pünktliche Lieferung und Geräte in tollem Zustand. Ich werde den Service immer wieder nutzen.', stars: 5 },
    { name: 'Carlos Mendes', city: 'Cascais', text: 'Fantastischer Kundenservice. Sie haben alle meine Fragen per WhatsApp innerhalb von Minuten beantwortet.', stars: 5 },
    { name: 'Sofia Pinto', city: 'Aveiro', text: 'Gehstützen zu mieten war sehr einfach. Die Website ist intuitiv und die Lieferung erfolgte wie vereinbart.', stars: 4 },
    { name: 'James Wilson', city: 'London, Großbritannien', text: 'Ich war einen Monat in Lissabon und brauchte einen Rollstuhl. Gestos Ágeis lieferte ihn am nächsten Morgen ins Hotel. Herausragender Service!', stars: 5 },
    { name: 'Marie Dupont', city: 'Paris, Frankreich', text: 'Einwandfreier Service! Ich habe während meines Aufenthalts in Porto Gehstützen gemietet. Schnelle Lieferung und hochwertige Geräte.', stars: 5 },
    { name: 'Klaus Müller', city: 'Berlin, Deutschland', text: 'Sehr guter Service! Ich habe einen Rollstuhl für meinen Vater gemietet. Schnelle Lieferung und freundliches Personal.', stars: 5 },
    { name: 'Emily Johnson', city: 'New York, USA', text: 'Ich habe während unseres Aufenthalts in Cascais ein Krankenbett für meine Mutter gemietet. Das Team war unglaublich hilfsbereit und professionell.', stars: 5 },
  ],
};

export const gaPageFaqs = {
  pt: [
    { q: 'Qual é o prazo de entrega?', a: 'Normalmente entregamos no dia seguinte à confirmação da reserva. Para reservas urgentes, contacte-nos diretamente.' },
    { q: 'Posso cancelar a minha reserva?', a: 'Sim. Cancelamentos com mais de 48h de antecedência são gratuitos. Para cancelamentos com menos de 48h, poderá ser aplicada uma taxa.' },
    { q: 'Os equipamentos são novos?', a: 'Os nossos equipamentos são regularmente revistos, higienizados e certificados, novos ou recondicionados em excelente estado.' },
    { q: 'Quais são os métodos de pagamento aceites?', a: 'Aceitamos MB Way, Multibanco, transferência bancária e pagamento em loja.' },
    { q: 'O que faço se o equipamento avariar?', a: 'Contacte-nos imediatamente via WhatsApp ou telefone. Substituiremos o equipamento sem custos adicionais.' },
    { q: 'Existe caução?', a: 'Alguns equipamentos requerem caução reembolsável, devolvida na íntegra na recolha, se o equipamento estiver em bom estado.' },
  ],
  en: [
    { q: 'What is the delivery time?', a: 'We typically deliver the day after reservation confirmation. For urgent requests, contact us directly.' },
    { q: 'Can I cancel my reservation?', a: 'Yes. Cancellations made more than 48 hours in advance are free. Cancellations within 48 hours may incur a fee.' },
    { q: 'Is the equipment new?', a: 'Our equipment is regularly inspected, sanitized and certified — new or expertly reconditioned.' },
    { q: 'What payment methods are accepted?', a: 'We accept MB Way, Multibanco, bank transfer and in-store payment.' },
    { q: 'What if the equipment breaks down?', a: 'Contact us immediately via WhatsApp or phone. We will replace it at no extra cost.' },
    { q: 'Is there a security deposit?', a: 'Some equipment requires a refundable deposit, returned in full upon collection if the equipment is in good condition.' },
  ],
  es: [
    { q: '¿Cuál es el plazo de entrega?', a: 'Normalmente entregamos al día siguiente de la confirmación de la reserva. Para reservas urgentes, contáctenos directamente.' },
    { q: '¿Puedo cancelar mi reserva?', a: 'Sí. Las cancelaciones con más de 48h de antelación son gratuitas. Para cancelaciones con menos de 48h, puede aplicarse una tarifa.' },
    { q: '¿Los equipos son nuevos?', a: 'Nuestros equipos son revisados, higienizados y certificados regularmente, nuevos o reacondicionados en excelente estado.' },
    { q: '¿Qué métodos de pago se aceptan?', a: 'Aceptamos MB Way, Multibanco, transferencia bancaria y pago en tienda.' },
    { q: '¿Qué hago si el equipo se avería?', a: 'Contáctenos inmediatamente vía WhatsApp o teléfono. Reemplazaremos el equipo sin coste adicional.' },
    { q: '¿Hay depósito?', a: 'Algunos equipos requieren un depósito reembolsable, devuelto íntegramente al recoger si el equipo está en buen estado.' },
  ],
  fr: [
    { q: "Quel est le délai de livraison ?", a: 'Nous livrons généralement le lendemain de la confirmation de la réservation. Pour les demandes urgentes, contactez-nous directement.' },
    { q: 'Puis-je annuler ma réservation ?', a: 'Oui. Les annulations effectuées plus de 48h à l’avance sont gratuites. Les annulations à moins de 48h peuvent entraîner des frais.' },
    { q: 'Le matériel est-il neuf ?', a: 'Notre matériel est régulièrement inspecté, désinfecté et certifié, neuf ou reconditionné en excellent état.' },
    { q: 'Quels moyens de paiement acceptez-vous ?', a: 'Nous acceptons MB Way, Multibanco, le virement bancaire et le paiement en magasin.' },
    { q: 'Que faire si le matériel tombe en panne ?', a: 'Contactez-nous immédiatement via WhatsApp ou par téléphone. Nous remplacerons le matériel sans frais supplémentaires.' },
    { q: 'Y a-t-il une caution ?', a: 'Certains matériels exigent une caution remboursable, rendue en totalité à la récupération si le matériel est en bon état.' },
  ],
  it: [
    { q: 'Qual è il tempo di consegna?', a: 'Consegniamo generalmente il giorno dopo la conferma della prenotazione. Per richieste urgenti, contattaci direttamente.' },
    { q: 'Posso annullare la mia prenotazione?', a: 'Sì. Le cancellazioni con più di 48 ore di preavviso sono gratuite. Le cancellazioni entro le 48 ore possono comportare una tariffa.' },
    { q: 'Le attrezzature sono nuove?', a: 'Le nostre attrezzature sono regolarmente ispezionate, sanificate e certificate, nuove o rigenerate in ottimo stato.' },
    { q: 'Quali metodi di pagamento sono accettati?', a: 'Accettiamo MB Way, Multibanco, bonifico bancario e pagamento in negozio.' },
    { q: 'Cosa faccio se l’attrezzatura si guasta?', a: 'Contattaci immediatamente via WhatsApp o telefono. Sostituiremo l’attrezzatura senza costi aggiuntivi.' },
    { q: 'C’è una cauzione?', a: 'Alcune attrezzature richiedono una cauzione rimborsabile, restituita per intero al ritiro se l’attrezzatura è in buono stato.' },
  ],
  de: [
    { q: 'Wie lange dauert die Lieferung?', a: 'Wir liefern in der Regel am Tag nach der Bestätigung der Reservierung. Für dringende Anfragen kontaktieren Sie uns direkt.' },
    { q: 'Kann ich meine Reservierung stornieren?', a: 'Ja. Stornierungen mehr als 48 Stunden im Voraus sind kostenlos. Bei Stornierungen unter 48 Stunden können Gebühren anfallen.' },
    { q: 'Sind die Geräte neu?', a: 'Unsere Geräte werden regelmäßig geprüft, desinfiziert und zertifiziert — neu oder fachgerecht aufbereitet in hervorragendem Zustand.' },
    { q: 'Welche Zahlungsmethoden werden akzeptiert?', a: 'Wir akzeptieren MB Way, Multibanco, Banküberweisung und Zahlung im Geschäft.' },
    { q: 'Was mache ich, wenn das Gerät ausfällt?', a: 'Kontaktieren Sie uns umgehend via WhatsApp oder Telefon. Wir ersetzen das Gerät ohne zusätzliche Kosten.' },
    { q: 'Gibt es eine Kaution?', a: 'Einige Geräte erfordern eine erstattungsfähige Kaution, die bei Abholung vollständig zurückgegeben wird, wenn das Gerät in gutem Zustand ist.' },
  ],
};

export const getGaPageStrings = (lang) => gaPageStrings[lang] || gaPageStrings.pt;
export const getGaPageTestimonials = (lang) => gaPageTestimonials[lang] || gaPageTestimonials.en;
export const getGaPageFaqs = (lang) => gaPageFaqs[lang] || gaPageFaqs.pt;